// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`
}

const ROOTS_AUTH = '/auth'
const ROOTS_DASHBOARD = '/dashboard'

export const ROOTS_LANDING_PAGE = process.env.REACT_APP_LANDING_PAGE_URL

export const PATH_AFTER_LOGIN = path(ROOTS_DASHBOARD, '/track/events')

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  operatorLogin: path(ROOTS_AUTH, '/operator/login'),
}

export const PATH_PASSWORD = {
  resetPassword: '/forgot-password',
  newPassword: '/reset-password',
}

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  page403: '/403',
  page404: '/404',
  page500: '/500',
}

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  blank: path(ROOTS_DASHBOARD, '/blank'),
  track: {
    root: path(ROOTS_DASHBOARD, '/track'),
    events: path(ROOTS_DASHBOARD, '/track/events'),
    categories: (eventId) => path(ROOTS_DASHBOARD, `/track/events/${eventId}/categories`),
    reports: (eventId) => path(ROOTS_DASHBOARD, `/track/events/${eventId}/reports`),
    panel: (categoryId) => path(ROOTS_DASHBOARD, `/track/panel/${categoryId}`),
    publicPanel: (categoryId) => `/track/public/panel/${categoryId}`,
    audit: (ticketId) => path(ROOTS_DASHBOARD, `/track/audit/${ticketId}`),
  },
}
